export default __webpack_public_path__ + "static/media/boSystem.280af9c6.png";